module.exports = __webpack_public_path__ + "static/media/9010_7021.21dc5f96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/9010_7021.jpg
// module id = 355
// module chunks = 0